<template>
  <div>
    <h3>
      Neu
    </h3>
    <div
      v-for="(article, key) in news.unread"
      :key="`unread-${key}`"
      class="row"
    >
      <customer-news-article
        @article_read="article_read"
        :article="article"
        unread
      ></customer-news-article>
    </div>
    <div v-if="news.unread && !news.unread.length">
      Keine Neuigkeiten
    </div>
    <hr />
    <h3>
      Ältere Beiträge
    </h3>
    <div v-for="(article, key) in news.read" :key="`read-${key}`" class="row">
      <customer-news-article :article="article"></customer-news-article>
    </div>
  </div>
</template>

<script>
import { getDateTimeHtml } from "@/js/date";
export default {
  data() {
    return {
      news: {}
    };
  },
  mounted() {
    this.$http.get(`/api/v1/news/show`).then(response => {
      this.news = response.data;
    });
  },
  methods: {
    article_read(newsId) {
      let index = this.news.unread.findIndex(unread => unread.id == newsId);
      if (index != -1) {
        let article = this.news.unread[index];
        this.news.unread.splice(index, 1);
        this.news.read.push(article);
        this.news.read.sort(function(a, b) {
          if (a.release_time > b.release_time) {
            return -1;
          }
          return 1;
        });
      }
    },
    releaseTime(time) {
      return getDateTimeHtml(time);
    }
  }
};
</script>
